import initDialog from '../initDialog'

import { RemoveDialog } from '../RemoveDialog'

import api from '../../../configs/api'

const styles = () => ({});

class RemoveVeterinarianDialog extends RemoveDialog
{
    getLocale = () => this.props.locale.dialogs.application.veterinarian.remove ;
}

RemoveVeterinarianDialog.defaultProps =
{
    ...RemoveDialog.defaultProps,
    uri    : api.veterinarians.url,
    useUrl : true
};

RemoveVeterinarianDialog.propTypes =
{
    ...RemoveDialog.propTypes
};

export default initDialog({ styles })( RemoveVeterinarianDialog );
